import React, { useEffect, useMemo } from 'react';
import {
  useSwapAllTokens,
  useSwapAllTokensSearch,
} from './api/useSwapTokenApi';
import { IWeb3ChainType } from '../providers/web3Provider/type';
import useChains from './useChains';
import { filterSwapChainId } from '../util/swap';
import { useTomo } from '../TomoContext';

export type ISwapTokenType = {
  chainId?: string;
  marketCap?: number;
  address?: string;
  chain: string;
  createdTime: string;
  decimals: number;
  displayName: string;
  id: number;
  imageUrl: string;
  isNative: boolean;
  isTomoji: boolean;
  name: string;
  priceChangeH24: number;
  priceUsd: string;
  supportRango: boolean;
  symbol: string;
  updatedTime: string;
  volumeH24: string;
};

const useSwapTokens = ({
  chain,
  content,
}: {
  chain: IWeb3ChainType | undefined;
  content: string | undefined;
}) => {
  const tomo = useTomo();
  const swapTokenQuery = useSwapAllTokens();

  const swapTokenSearchQuery = useSwapAllTokensSearch({
    content,
    chain: filterSwapChainId(chain),
    config: {
      url: tomo?.endpoints[0] + 'sky/api/',
      tmaid: tomo.tmaid,
      tmakey: tomo.tmakey,
    },
  });

  const tokens = useMemo(() => {
    if (!!content && swapTokenSearchQuery.data) {
      const swapSearchTokens = swapTokenSearchQuery?.data?.result as
        | ISwapTokenType[]
        | undefined;
      return swapSearchTokens ? swapSearchTokens : [];
    }

    if (swapTokenQuery.data) {
      const swapTokens = swapTokenQuery?.data?.result as
        | ISwapTokenType[]
        | undefined;
      const chainName = filterSwapChainId(chain);

      const filterTokens = swapTokens
        .filter(item => {
          return chainName == 'POLYGON_POS'
            ? item?.chain === 'POLYGON_POS'
            : item?.chain === chainName;
        })
        .sort((a, b) => {
          const aD = a?.address ? 1 : 0;
          const bD = b?.address ? 1 : 0;
          return aD - bD;
        });

      return filterTokens ? filterTokens : [];
    }
    return [];
  }, [swapTokenQuery.data, swapTokenSearchQuery.data]);

  return {
    tokens,
    loading: !!content
      ? swapTokenSearchQuery.isLoading
      : swapTokenQuery.isLoading,
  };
};

export default useSwapTokens;
